import React, { useState } from "react";
import "./App.css";
import { Outlet, useLocation } from "react-router-dom";
import PageHeader from "./components/PageHeader/PageHeader";
import TestLogin from "./models/TestLogin";
import PageHeaderPublic from "./components/PageHeader/PageHeaderPublic";
import { useCookies } from "react-cookie";
import WaitingAlert from "./components/WaitingAlert";
import PageHeaderWaiting from "./components/PageHeader/PageHeaderWaiting";
import SharedLandingPage from "./pages/SharedLandingPage";
import TermsAndConditions from "./components/TermsAndConditions";
import config from "./config";
import HomePagePublic from "./pages/HomePagePublic";

function App() {
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [hasUserGroups, setHasUserGroups] = useState<boolean>(false);
  const [authChecked, setAuthChecked] = useState<boolean>(false);
  const [cookies] = useCookies(["userGroups"]);
  const [page, setPage] = useState<string>("home");
  const location = useLocation();

  let [openDialog, setOpenDialog] = useState<boolean>(false);

  React.useEffect(() => {
    console.log(
      "Environment: " +
        import.meta.env.MODE +
        ". App useEffect triggered. Checking authentication... ",
    );
    let retryCount = 0;
    const MAX_RETRIES = 2;

    (async () => {
      const redirectLoginUrl =
        location.pathname &&
        location.pathname !== "/" &&
        !location.pathname.includes("/public/landing")
          ? location.pathname
          : null;

      console.log("redirectLoginUrl: " + redirectLoginUrl);

      let isLoggedIn = false;

      // Retry loop: if TestLogin fails, retry up to MAX_RETRIES times with exponential backoff
      while (!isLoggedIn && retryCount <= MAX_RETRIES) {
        if (retryCount > 0) {
          console.log(` Retrying TestLogin (${retryCount}/${MAX_RETRIES})...`);
          // Wait before retrying (exponential backoff: 200ms, 400ms)
          const delay = 200 * retryCount;
          await new Promise((resolve) => setTimeout(resolve, delay));
        }

        isLoggedIn = await TestLogin(redirectLoginUrl);
        console.log(`App isLoggedIn (attempt ${retryCount + 1}):`, isLoggedIn);

        if (!isLoggedIn) {
          retryCount++;
        }
      }

      if (isLoggedIn) {
        setIsLogged(true);
        const userGroups = cookies.userGroups ? cookies.userGroups : null;
        //const hasGroups = userGroups && userGroups.length > 0 ? true : false;
        const hasGroups =
          userGroups &&
          Array.isArray(userGroups) &&
          userGroups.length > 0 &&
          userGroups.some((group) =>
            config.portalCognitoGroups.includes(group),
          );

        setHasUserGroups(hasGroups);
      } else {
        location.pathname && location.pathname === "/"
          ? setPage("home")
          : setPage("shared");
      }

      if (import.meta.env.MODE === "dev") {
        // for local test
        setIsLogged(true);
        const userGroups = ["PortalExternalPress", "PortalInternalPress"];

        const hasGroups =
          userGroups &&
          Array.isArray(userGroups) &&
          userGroups.length > 0 &&
          userGroups.some((group) =>
            config.portalCognitoGroups.includes(group),
          );

        console.log("hasGroups " + hasGroups);

        setHasUserGroups(true);
      }

      // Mark auth check as complete so the UI can render.
      // In dev mode this is set after the hardcoded override above.
      setAuthChecked(true);
    })();
  }, [cookies.userGroups, location.pathname]);

  return (
    <>
      {console.log(
        "Rendering App. isLogged:",
        isLogged,
        " hasUserGroups:",
        hasUserGroups,
        " authChecked:",
        authChecked,
        " page:",
        page,
      )}

      {/* Render nothing until the auth check completes to avoid a flash of
          unauthenticated UI (e.g. PageHeaderPublic appearing briefly before
          isLogged becomes true). Skipped in dev mode where auth is hardcoded. */}
      {!authChecked && import.meta.env.MODE !== "dev" ? null : (
        <>
          {isLogged ? (
            <>
              {hasUserGroups ? (
                <div className="font-skyRegular container mx-auto bg-white-100 h-full">
                  <PageHeader />
                  <Outlet />
                </div>
              ) : (
                <div className="font-skyRegular container mx-auto bg-white-100 h-full">
                  <PageHeaderWaiting />
                  <WaitingAlert />
                  <HomePagePublic />
                </div>
              )}
            </>
          ) : (
            <div className="font-skyRegular container mx-auto bg-white-100 h-full">
              <PageHeaderPublic />
              {page === "shared" && <SharedLandingPage />}
              {page === "home" && <HomePagePublic />}
            </div>
          )}
        </>
      )}
      <TermsAndConditions
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      ></TermsAndConditions>
    </>
  );
}

export default App;
